import React, { Component } from "react";
import PropTypes from "prop-types";

export class Booking extends Component {
  static propTypes = {};

  render() {
    const options = ["One", "Two", "Three", "Four", "Five"];
    const onOptionChangeHandler = (event) => {
      console.log("User Selected Value - ", event.target.value);
    };
    return (
      <>
        <section className="banneres">
          <div className="container">
            <div className="banner-info">
              <h6>
                <a href="home">Home</a> | <a href=""></a> Booking
              </h6>
              <h2>Booking</h2>
            </div>
          </div>
        </section>

        <section className="booking">
          <div className="container">
            <form action="">
              <div className="contact-info">
                <h1>Contact Details</h1>
                <div className="finfo">
                  <div>
                    <label htmlFor="">First Name</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                  <div>
                    <label htmlFor="">Last Name</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                  <div className="div">
                    <label htmlFor=""> Select City</label>
                    <select onChange={onOptionChangeHandler}>
                      <option>Please choose one option</option>
                      {options.map((option, index) => {
                        return <option key={index}>{option}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="finfo">
                  <div>
                    <label htmlFor="">Email</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                  <div>
                    <label htmlFor="">Address</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                  <div>
                    <label htmlFor="">Phone</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                </div>
              </div>
              <div className="guest">
                <h1>Guest Details</h1>
                <h2>Superior Room - Twin - Best available</h2>
                <div className="finfo">
                  <div>
                    <label htmlFor="">First Name</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                  <div>
                    <label htmlFor="">Last Name</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                  <div>
                    <label htmlFor=""> Select Rooms</label>
                    <select onChange={onOptionChangeHandler}>
                      <option>Please choose one option</option>
                      {options.map((option, index) => {
                        return <option key={index}>{option}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="finfo">
                  <div>
                    <label htmlFor="">Age</label>
                    <input type="text" placeholder="First Name" />
                  </div>
                  <div>
                    <label htmlFor="">id Profe</label>
                    <input
                      className="file"
                      type="file"
                      placeholder="First Name"
                    />
                  </div>
                  <div>
                    <label htmlFor=""> Select Person</label>
                    <select name="" id="">
                      <option value="null">---Select Person---</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                      <option value="1">1</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </section>
      </>
    );
  }
}

export default Booking;
